import { render, staticRenderFns } from "./review-transfer.vue?vue&type=template&id=0ed05a41"
import script from "./review-transfer.vue?vue&type=script&lang=js"
export * from "./review-transfer.vue?vue&type=script&lang=js"
import style0 from "./review-transfer.vue?vue&type=style&index=0&id=0ed05a41&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports